import React from 'react'

const Survey = () => {
  return (
    <div>Survey</div>
  )
}

export default Survey